export { default } from "./ConnectedIntlProvider";
export { appIntl } from "./ConnectedIntlProvider";
